export default [
  {
    key: 'avatar',
    label: '',
    _style: 'width: 50px',
    sorter: false,
    slot: true,
  },
  {
    key: 'account_name',
    label: 'ユーザ名',
    _style: 'min-width: 100px',
    sorter: false,
    slot: true,
  },
  {
    key: 'admin_note',
    label: '備考',
    _style: 'min-width: 350px',
    sorter: false,
    slot: true,
  },
  {
    key: 'weight_at',
    label: '最終計測日時',
    _style: 'min-width: 150px',
    sorter: false,
  },
  {
    key: 'compare_weight',
    label: '体重変位',
    _style: 'min-width: 100px',
    sorter: false,
  },
  {
    key: 'compare_BodyFatRate',
    label: '体脂肪変位',
    _style: 'min-width: 100px',
    sorter: false,
  },
  {
    key: 'compare_at',
    label: '比較計測日時',
    _style: 'min-width: 150px',
    sorter: false,
  },
]
